import request from '@/router/axios'

//运动员详情页
export function GetAthleteDetail(query) {
    return request({
        url: '/api/services/app/AthleteCenter/GetAthleteDetail',
        method: 'post',
        data: query
    })
 }

//培训记录
export function GetCoachTrainEnrolment(query) {
   return request({
       url: '/api/services/app/TrainingCenter/GetCoachTrainEnrolment',
       method: 'post',
       data: query
   })
}
//查看成绩
export function GetScoreToViewList(query) {
   return request({
       url: '/api/services/app/TrainingCenter/GetScoreToViewList',
       method: 'post',
       data: query
   })
}
//工作记录
export function GetWorkRecordList(query) {
   return request({
       url: '/api/services/app/TrainingCenter/GetWorkRecordList',
       method: 'post',
       data: query
   })
}
//下载工作记录
export function DownloadAttachments(query) {
    return request({
        url: '/api/services/app/TrainingCenter/DownloadAttachments',
        method: 'post',
        data: query
    })
 }
 //上传工作记录
export function UploadTestClassAttachments(query) {
    return request({
        url: '/api/services/app/TrainingCenter/UploadTestClassAttachments',
        method: 'post',
        data: query
    })
 }
//等级证书
export function GetPersonalCertificate(query) {
   return request({
       url: '/api/services/app/AthleteCenter/GetPersonalCertificate',
       method: 'post',
       data: query
   })
}

//申请等级证书
export function GetPaperCertificate(query) {
   return request({
       url: '/api/services/app/AthleteCenter/GetPaperCertificate',
       method: 'post',
       data: query
   })
}
//获取证书等级
export function GetGradeList(query) {
   return request({
       url: '/api/services/app/AthleteCenter/GetGradeList',
       method: 'post',
       data: query
   })
}
//申请等级证书记录
export function GetCertificateRecordList(query) {
   return request({
       url: '/api/services/app/AthleteCenter/GetCertificateRecordList',
       method: 'post',
       data: query
   })
}

//机构领取记录
export function ApplicationWayList(query) {
    return request({
        url: '/api/services/app/AthleteCenter/ApplicationWayList',
        method: 'post',
        data: query
    })
 }
//l领取方式
export function GetApplicationWay(query) {
   return request({
       url: '/api/services/app/AthleteCenter/GetApplicationWay',
       method: 'post',
       data: query
   })
}
//缴费记录
export function GetPersonalOrderRecord(query) {
   return request({
       url: '/api/services/app/AthleteCenter/GetPersonalOrderRecord',
       method: 'post',
       data: query
   })
}

//考评员详情页
export function getUserCoachData(query) {
    return request({
        url: '/api/services/app/TestOrg/getUserCoachData',
        method: 'post',
        data: query
    })
}

//考评员详情页2
export function getUserCoachData2(query) {
    return request({
        url: '/api/services/app/TestOrg/getUserCoachData2',
        method: 'post',
        data: query
    })
}
// 考评员报名
export function TrainClassSignUpList(query) {
    return request({
        url: '/api/services/app/TrainClass/TrainClassSignUpList',
        method: 'post',
        data: query
    })
 }

 // 考评员订单
export function TrainClassData(query) {
    return request({
        url: '/api/services/app/TrainClass/TrainClassData',
        method: 'post',
        data: query
    })
 }